<header>
  <ok-app-header [homeLinkTooltip]="'Gå til forsiden'" [disableHomeLink]="disableOkLink()">
    <ok-dark-mode-toggle tooltipPosition="below" />
  </ok-app-header>
</header>

<main>
  <router-outlet></router-outlet>
</main>

<footer>
  <img src="assets/images/ok-logo.svg" alt="OK a.m.b.a" />
  <div class="page_version">Version : {{ version() }}</div>
</footer>
